import { initializeApp } from "firebase/app";
import { collection, getDocs, getFirestore } from "firebase/firestore";
import { firestoreClientConfig } from "../config/firestoreConfig";

const queryFirebaseCollection = async (
  collectionName: string,
  document: string,
  useSecondaryFirebase = false
) => {
  try {
    let fbApp;
    if (useSecondaryFirebase) {
      fbApp = initializeApp(firestoreClientConfig, "secondaryfb");
    } else {
      fbApp = initializeApp(firestoreClientConfig);
    }
    const db = getFirestore(fbApp);
    const snapshot = await getDocs(collection(db, collectionName));
    const data: any = {};
    snapshot.forEach((doc) => {
      if (doc) {
        const docData = doc.data();
        data[doc.id] = docData;
      }
    });

    return data?.[document];
  } catch (error) {
    return {
      error,
    };
  }
};

export default queryFirebaseCollection;
